import type { Language } from '@expenditure/core';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json';
import km from '../locales/km.json';

const STORAGE_KEY = 'expenditure.language';

function initialLanguage(): Language {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'en' || saved === 'km') return saved;
  } catch {
    // Storage may be unavailable (private mode); fall through.
  }
  const tgLanguage = window.Telegram?.WebApp?.initDataUnsafe?.user as { language_code?: string } | undefined;
  const code = tgLanguage?.language_code ?? navigator.language;
  return code?.toLowerCase().startsWith('km') ? 'km' : 'en';
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, km: { translation: km } },
  lng: initialLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setLanguage(language: Language): void {
  void i18n.changeLanguage(language);
  document.documentElement.lang = language;
  try {
    localStorage.setItem(STORAGE_KEY, language);
  } catch {
    // Ignore; the server keeps the preference too.
  }
}

document.documentElement.lang = i18n.language;

export default i18n;
